/* ==========================================================================
   The Storied Shelf - Collection JS v3
   Block 1: Filter chips, sort dropdown, infinite scroll, 18+ toggle
   Block 2: Quick buy + Stepper + Toast + Cart count bubble
   ========================================================================== */


/* ==========================================================================
   BLOCK 1: Filter / Sort / Pagination / Adult toggle
   ========================================================================== */
(function() {
  'use strict';

  // -------------------------------------------------------------------------
  // 1. Filter chip dropdowns
  // -------------------------------------------------------------------------

  document.addEventListener('click', function(event) {
    var openChips = document.querySelectorAll('.storied-filter-chip[open]');
    if (openChips.length === 0) return;

    openChips.forEach(function(chip) {
      if (!chip.contains(event.target)) {
        chip.open = false;
      }
    });
  });

  document.addEventListener('toggle', function(event) {
    var target = event.target;
    if (!target.classList || !target.classList.contains('storied-filter-chip')) return;
    if (!target.open) return;

    var allChips = document.querySelectorAll('.storied-filter-chip');
    allChips.forEach(function(chip) {
      if (chip !== target && chip.open) {
        chip.open = false;
      }
    });
  }, true);

  // -------------------------------------------------------------------------
  // 2. Sort dropdown auto-submit
  // -------------------------------------------------------------------------

  var sortSelects = document.querySelectorAll('[data-storied-sort]');
  sortSelects.forEach(function(select) {
    select.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  // -------------------------------------------------------------------------
  // 3. Adult content opt-in toggle
  // -------------------------------------------------------------------------

  var STORAGE_KEY = 'storied_show_adult';

  function isAdultOptedIn() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setAdultOptIn(value) {
    try {
      if (value) {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } else {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      // sessionStorage unavailable
    }
  }

  function applyAdultVisibility() {
    var showAdult = isAdultOptedIn();
    var adultItems = document.querySelectorAll('[data-storied-adult-item]');
    var hiddenCount = 0;

    adultItems.forEach(function(item) {
      if (showAdult) {
        item.classList.add('storied-collection__grid-item--visible');
      } else {
        item.classList.remove('storied-collection__grid-item--visible');
        hiddenCount++;
      }
    });

    var toggleBtn = document.querySelector('[data-storied-adult-toggle]');
    var toggleLabel = document.querySelector('[data-storied-adult-toggle-label]');
    var gateText = document.querySelector('[data-storied-adult-text]');

    if (toggleBtn) {
      toggleBtn.setAttribute('aria-pressed', showAdult ? 'true' : 'false');
      toggleBtn.classList.toggle('storied-collection__adult-gate-toggle--active', showAdult);
    }
    if (toggleLabel) {
      toggleLabel.textContent = showAdult ? 'Hide adult items' : 'Show adult items';
    }
    if (gateText) {
      gateText.textContent = showAdult
        ? 'Adult-themed items are being shown.'
        : 'Some items in this collection contain adult language & themes. They\'re hidden by default.';
    }

    updateVisibleCount(hiddenCount);
  }

  function updateVisibleCount(hiddenAdultCount) {
    var countNumber = document.querySelector('[data-storied-count-number]');
    var countLabel = document.querySelector('[data-storied-count-label]');
    if (!countNumber) return;

    var totalItems = document.querySelectorAll('[data-storied-item]').length;
    var visibleCount = totalItems - hiddenAdultCount;

    countNumber.textContent = visibleCount;
    if (countLabel) {
      countLabel.textContent = visibleCount === 1 ? 'item' : 'items';
    }
  }

  var adultToggle = document.querySelector('[data-storied-adult-toggle]');
  if (adultToggle) {
    adultToggle.addEventListener('click', function() {
      var newValue = !isAdultOptedIn();
      setAdultOptIn(newValue);
      applyAdultVisibility();
    });

    applyAdultVisibility();
  }

  // -------------------------------------------------------------------------
  // 4. Infinite scroll
  // -------------------------------------------------------------------------

  var AUTO_LOAD_LIMIT = 3;
  var autoLoadsPerformed = 0;
  var isLoading = false;

  function getPaginationLink() {
    return document.querySelector('[data-storied-next-url]');
  }

  function getGrid() {
    return document.querySelector('[data-storied-grid]');
  }

  function loadNextPage(callback) {
    var link = getPaginationLink();
    if (!link || isLoading) return;

    var nextUrl = link.getAttribute('href');
    if (!nextUrl) return;

    isLoading = true;
    link.classList.add('storied-collection__pagination-link--loading');
    var originalText = link.textContent;
    link.textContent = 'Loading...';

    fetch(nextUrl)
      .then(function(response) {
        if (!response.ok) throw new Error('Network error');
        return response.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newItems = doc.querySelectorAll('[data-storied-item]');
        var currentGrid = getGrid();
        if (currentGrid) {
          newItems.forEach(function(item) {
            currentGrid.appendChild(item);
          });
        }

        var newPagination = doc.querySelector('[data-storied-next-url]');
        var currentPaginationContainer = document.querySelector('[data-storied-pagination]');
        if (newPagination && currentPaginationContainer) {
          link.setAttribute('href', newPagination.getAttribute('href'));
          link.textContent = originalText;
          link.classList.remove('storied-collection__pagination-link--loading');
        } else if (currentPaginationContainer) {
          currentPaginationContainer.remove();
        }

        isLoading = false;

        applyAdultVisibility();

        if (callback) callback();
      })
      .catch(function(error) {
        console.error('Failed to load next page:', error);
        isLoading = false;
        link.textContent = originalText;
        link.classList.remove('storied-collection__pagination-link--loading');
      });
  }

  function setupInfiniteScroll() {
    var link = getPaginationLink();
    if (!link) return;

    link.addEventListener('click', function(event) {
      event.preventDefault();
      loadNextPage();
    });

    if (!('IntersectionObserver' in window)) {
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        if (autoLoadsPerformed >= AUTO_LOAD_LIMIT) {
          observer.disconnect();
          return;
        }
        autoLoadsPerformed++;
        loadNextPage(function() {
          var newLink = getPaginationLink();
          if (newLink && autoLoadsPerformed < AUTO_LOAD_LIMIT) {
            observer.observe(newLink);
          }
        });
      });
    }, {
      rootMargin: '200px'
    });

    observer.observe(link);
  }

  setupInfiniteScroll();

})();


/* ==========================================================================
   BLOCK 2: Quick Buy + Stepper + Toast + Cart count bubble
   ========================================================================== */
(function() {
  'use strict';

  // -------------------------------------------------------------------------
  // Toast notification
  // -------------------------------------------------------------------------

  function getToastContainer() {
    var container = document.querySelector('.storied-toast-container');
    if (!container) {
      container = document.createElement('div');
      container.className = 'storied-toast-container';
      container.setAttribute('aria-live', 'polite');
      container.setAttribute('aria-atomic', 'true');
      document.body.appendChild(container);
    }
    return container;
  }

  function showToast(message, options) {
    options = options || {};
    var isError = !!options.error;

    var container = getToastContainer();

    var toast = document.createElement('div');
    toast.className = 'storied-toast' + (isError ? ' storied-toast--error' : '');

    var icon = document.createElement('span');
    icon.className = 'storied-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = isError ? '!' : '✓';
    toast.appendChild(icon);

    var msg = document.createElement('span');
    msg.className = 'storied-toast__message';
    msg.textContent = message;
    toast.appendChild(msg);

    if (!isError) {
      var link = document.createElement('a');
      link.className = 'storied-toast__link';
      link.href = '/cart';
      link.textContent = 'View cart';
      toast.appendChild(link);
    }

    container.appendChild(toast);
    void toast.offsetWidth;
    toast.classList.add('is-visible');

    setTimeout(function() {
      toast.classList.remove('is-visible');
      setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 350);
    }, options.duration || 3500);
  }


  // -------------------------------------------------------------------------
  // Stepper helpers
  // -------------------------------------------------------------------------

  function getStepperByVariant(variantId) {
    return document.querySelector('[data-storied-stepper][data-variant-id="' + variantId + '"]');
  }

  function getAddButtonByVariant(variantId) {
    var stepper = getStepperByVariant(variantId);
    if (!stepper) return null;
    var buyContainer = stepper.closest('[data-storied-buy]');
    if (!buyContainer) return null;
    return buyContainer.querySelector('[data-storied-add-to-cart]:not(.storied-card__buy-button--confirm)');
  }

  function showStepper(variantId, quantity) {
    var stepper = getStepperByVariant(variantId);
    if (!stepper) return;

    var addButton = getAddButtonByVariant(variantId);

    var countEl = stepper.querySelector('[data-storied-stepper-count]');
    if (countEl) countEl.textContent = quantity;

    if (addButton) addButton.setAttribute('hidden', '');
    stepper.removeAttribute('hidden');

    updatePlusButtonState(stepper, quantity);
  }

  function hideStepper(variantId) {
    var stepper = getStepperByVariant(variantId);
    if (!stepper) return;

    var addButton = getAddButtonByVariant(variantId);

    stepper.setAttribute('hidden', '');
    if (addButton) {
      addButton.removeAttribute('hidden');
      addButton.classList.remove('is-added', 'is-loading');
      var label = addButton.querySelector('.storied-card__buy-label');
      if (label) label.textContent = 'Add to cart';
    }
  }

  function updatePlusButtonState(stepper, quantity) {
    var plus = stepper.querySelector('[data-storied-stepper-plus]');
    if (!plus) return;

    var inventoryAttr = stepper.getAttribute('data-inventory-quantity');
    if (inventoryAttr === null || inventoryAttr === '') {
      plus.removeAttribute('disabled');
      return;
    }

    var inventory = parseInt(inventoryAttr, 10);
    if (isNaN(inventory)) {
      plus.removeAttribute('disabled');
      return;
    }

    if (quantity >= inventory) {
      plus.setAttribute('disabled', '');
    } else {
      plus.removeAttribute('disabled');
    }
  }

  function setSteppperLoading(stepper, loading) {
    if (!stepper) return;
    if (loading) {
      stepper.classList.add('is-loading');
    } else {
      stepper.classList.remove('is-loading');
    }
  }


  // -------------------------------------------------------------------------
  // AJAX cart operations
  // -------------------------------------------------------------------------

  function addToCart(variantId, quantity, button, productTitle) {
    if (!variantId) return;

    button.classList.add('is-loading');
    button.setAttribute('disabled', '');

    var formData = {
      items: [{
        id: parseInt(variantId, 10),
        quantity: quantity || 1
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(err) {
            throw new Error(err.description || err.message || 'Could not add to cart');
          });
        }
        return response.json();
      })
      .then(function() {
        button.classList.remove('is-loading');
        button.removeAttribute('disabled');

        showToast((productTitle || 'Item') + ' added to cart');

        var stepper = getStepperByVariant(variantId);
        if (stepper) {
          fetchCartAndUpdate(variantId);
        }

        updateCartCount();
      })
      .catch(function(error) {
        console.error('Add to cart failed:', error);
        button.classList.remove('is-loading');
        button.removeAttribute('disabled');
        showToast(error.message || 'Could not add to cart', { error: true });
      });
  }

  function updateCartLineQuantity(variantId, newQuantity, stepper, productTitle) {
    setSteppperLoading(stepper, true);

    var updates = {};
    updates[variantId] = newQuantity;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(err) {
            throw new Error(err.description || err.message || 'Could not update cart');
          });
        }
        return response.json();
      })
      .then(function(cart) {
        setSteppperLoading(stepper, false);

        var actualQuantity = 0;
        if (cart.items) {
          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].variant_id) === String(variantId)) {
              actualQuantity = cart.items[i].quantity;
              break;
            }
          }
        }

        if (actualQuantity === 0) {
          hideStepper(variantId);
        } else {
          var countEl = stepper.querySelector('[data-storied-stepper-count]');
          if (countEl) countEl.textContent = actualQuantity;
          updatePlusButtonState(stepper, actualQuantity);
        }

        updateCartCount();
      })
      .catch(function(error) {
        console.error('Cart update failed:', error);
        setSteppperLoading(stepper, false);
        showToast(error.message || 'Could not update cart', { error: true });
      });
  }

  function fetchCartAndUpdate(variantId) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var qty = 0;
        if (cart.items) {
          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].variant_id) === String(variantId)) {
              qty = cart.items[i].quantity;
              break;
            }
          }
        }
        if (qty > 0) {
          showStepper(variantId, qty);
        }
      });
  }


  // -------------------------------------------------------------------------
  // Cart count bubble
  // -------------------------------------------------------------------------

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = cart.item_count || 0;

        var cartLinks = document.querySelectorAll('a[href="/cart"], a[href*="/cart"]');
        if (cartLinks.length === 0) return;

        cartLinks.forEach(function(link) {
          var bubble = link.querySelector('.cart-count-bubble');

          if (bubble) {
            var span = bubble.querySelector('span[aria-hidden="true"]');
            if (span) span.textContent = count;
            var hidden = bubble.querySelector('.visually-hidden');
            if (hidden) hidden.textContent = count + ' items';

            if (count === 0) {
              bubble.style.display = 'none';
            } else {
              bubble.style.display = '';
            }
          } else if (count > 0) {
            var newBubble = document.createElement('div');
            newBubble.className = 'cart-count-bubble';

            var visibleSpan = document.createElement('span');
            visibleSpan.setAttribute('aria-hidden', 'true');
            visibleSpan.textContent = count;
            newBubble.appendChild(visibleSpan);

            var hiddenSpan = document.createElement('span');
            hiddenSpan.className = 'visually-hidden';
            hiddenSpan.textContent = count + ' items';
            newBubble.appendChild(hiddenSpan);

            link.appendChild(newBubble);
          }
        });
      })
      .catch(function() { /* silent */ });
  }


  // -------------------------------------------------------------------------
  // Hydrate steppers on page load
  // -------------------------------------------------------------------------

  function hydrateSteppersFromCart() {
    var steppers = document.querySelectorAll('[data-storied-stepper]');
    if (steppers.length === 0) return;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart.items) return;

        var cartMap = {};
        cart.items.forEach(function(item) {
          cartMap[String(item.variant_id)] = item.quantity;
        });

        steppers.forEach(function(stepper) {
          var variantId = stepper.getAttribute('data-variant-id');
          var qty = cartMap[variantId];
          if (qty && qty > 0) {
            showStepper(variantId, qty);
          }
        });
      })
      .catch(function() { /* silent */ });
  }


  // -------------------------------------------------------------------------
  // Variant picker (multi-variant cards)
  // -------------------------------------------------------------------------

  function selectVariant(panel) {
    var selects = panel.querySelectorAll('[data-storied-variant-option]');
    var chosenValues = [];
    selects.forEach(function(s) { chosenValues.push(s.value); });
    var chosenKey = chosenValues.join('|');

    var dataNodes = panel.querySelectorAll('.storied-card__variant-data [data-variant-id]');
    var foundVariant = null;
    dataNodes.forEach(function(node) {
      if (node.getAttribute('data-variant-options') === chosenKey) {
        foundVariant = node;
      }
    });

    var confirmButton = panel.querySelector('[data-storied-add-to-cart]');
    if (!confirmButton) return;

    if (foundVariant) {
      var available = foundVariant.getAttribute('data-variant-available') === 'true';
      if (available) {
        confirmButton.setAttribute('data-variant-id', foundVariant.getAttribute('data-variant-id'));
        confirmButton.removeAttribute('disabled');
        var label = confirmButton.querySelector('.storied-card__buy-label');
        if (label) label.textContent = 'Add to cart';
      } else {
        confirmButton.setAttribute('disabled', '');
        var label2 = confirmButton.querySelector('.storied-card__buy-label');
        if (label2) label2.textContent = 'Sold out';
      }
    } else {
      confirmButton.setAttribute('disabled', '');
      var label3 = confirmButton.querySelector('.storied-card__buy-label');
      if (label3) label3.textContent = 'Unavailable';
    }
  }


  // -------------------------------------------------------------------------
  // Event delegation
  // -------------------------------------------------------------------------

  document.addEventListener('click', function(event) {
    var target = event.target;

    var minusBtn = target.closest('[data-storied-stepper-minus]');
    if (minusBtn) {
      event.preventDefault();
      if (minusBtn.hasAttribute('disabled')) return;
      var stepperMinus = minusBtn.closest('[data-storied-stepper]');
      if (!stepperMinus) return;
      var countElM = stepperMinus.querySelector('[data-storied-stepper-count]');
      var currentM = parseInt(countElM.textContent, 10) || 0;
      var newQtyM = Math.max(0, currentM - 1);
      var vIdM = stepperMinus.getAttribute('data-variant-id');
      var titleM = stepperMinus.getAttribute('data-product-title');
      updateCartLineQuantity(vIdM, newQtyM, stepperMinus, titleM);
      return;
    }

    var plusBtn = target.closest('[data-storied-stepper-plus]');
    if (plusBtn) {
      event.preventDefault();
      if (plusBtn.hasAttribute('disabled')) return;
      var stepperPlus = plusBtn.closest('[data-storied-stepper]');
      if (!stepperPlus) return;
      var countElP = stepperPlus.querySelector('[data-storied-stepper-count]');
      var currentP = parseInt(countElP.textContent, 10) || 0;
      var newQtyP = currentP + 1;
      var vIdP = stepperPlus.getAttribute('data-variant-id');
      var titleP = stepperPlus.getAttribute('data-product-title');
      updateCartLineQuantity(vIdP, newQtyP, stepperPlus, titleP);
      return;
    }

    var toggle = target.closest('[data-storied-buy-toggle]');
    if (toggle) {
      event.preventDefault();
      var panelId = toggle.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (panel) {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (expanded) {
          panel.setAttribute('hidden', '');
        } else {
          panel.removeAttribute('hidden');
          selectVariant(panel);
        }
      }
      return;
    }

    var addBtn = target.closest('[data-storied-add-to-cart]');
    if (addBtn) {
      event.preventDefault();
      if (addBtn.hasAttribute('disabled') || addBtn.classList.contains('is-loading')) return;
      var variantId = addBtn.getAttribute('data-variant-id');
      var productTitle = addBtn.getAttribute('data-product-title');
      addToCart(variantId, 1, addBtn, productTitle);
      return;
    }
  });

  document.addEventListener('change', function(event) {
    var target = event.target;
    if (!target.matches('[data-storied-variant-option]')) return;
    var panel = target.closest('[data-storied-variant-panel]');
    if (panel) selectVariant(panel);
  });


  // -------------------------------------------------------------------------
  // Initialize on page load
  // -------------------------------------------------------------------------

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateSteppersFromCart);
  } else {
    hydrateSteppersFromCart();
  }

})();